export class Menu {
  title: string;
  icon: string;
  active: boolean;
  group: string;
  badgeClass?: string[] | null;
  permissions?: string[] | null;
  items?: SubmenusEntity[] | null;
  routerLink?: string[];
  separator: boolean;
  featureName?: string[];
  command: () => void;
}

export class SubmenusEntity {
  title: string;
  icon: string;
  badgeClass?: string[] | null;
  routerLink?: string[];
  separator: boolean;
  command: () => void;
}
